import React, { useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import CreateReport from './components/CreateReport';
import DemandModel from './components/DemandModel';
import WeeklyDemandChart from './components/WeeklyDemandChart';
import DemandCalendar from './components/DemandCalendar';
import DemandConfig from './components/DemandConfig';
import Announcements from './components/Announcements';
import Strikes from './components/Strikes';
import EditLive from './components/EditLive';
import './App.css';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

const londonDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/London',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
}).format(new Date());
const defaultEndDate = new Date(`${londonDate}T12:00:00Z`);
defaultEndDate.setUTCDate(defaultEndDate.getUTCDate() + 6);
const defaultFilters = {
  startDate: londonDate,
  endDate: defaultEndDate.toISOString().slice(0, 10),
  minAttendance: 200
};

export default function App() {
  const [activeTab, setActiveTab] = useState('report');
  const [filters, setFilters] = useState(defaultFilters);
  return (
    <div className="app">
      <header className="app-header">
        <div><span className="eyebrow">CABRADAR / OPERATIONS</span><h1>Event timing desk</h1></div>
        <button className="header-settings header-settings-text" aria-label="Open demand configuration" title="Demand configuration" onClick={() => setActiveTab('config')}>Config</button>
      </header>
      <nav className="app-tabs" aria-label="Dashboard sections">
        <button className={activeTab === 'report' ? 'active' : ''} onClick={() => setActiveTab('report')}>Create report</button>
        <button className={activeTab === 'live' ? 'active' : ''} onClick={() => setActiveTab('live')}>Edit live</button>
        <button className={activeTab === 'weekly' ? 'active' : ''} onClick={() => setActiveTab('weekly')}>Weekly forecast</button>
        <span className="app-tabs-spacer" aria-hidden="true" />
        <button className={activeTab === 'demand' ? 'active' : ''} onClick={() => setActiveTab('demand')}>Demand features</button>
        <button className={activeTab === 'calendar' ? 'active' : ''} onClick={() => setActiveTab('calendar')}>Calendar</button>
        <button className={activeTab === 'announcements' ? 'active' : ''} onClick={() => setActiveTab('announcements')}>Announcements</button>
        <button className={activeTab === 'strikes' ? 'active' : ''} onClick={() => setActiveTab('strikes')}>Strikes</button>
      </nav>
      <main className="app-content">
        {activeTab === 'report' && <CreateReport filters={filters} setFilters={setFilters} />}
        {activeTab === 'live' && <EditLive />}
        {activeTab === 'demand' && <DemandModel />}
        {activeTab === 'weekly' && <WeeklyDemandChart />}
        {activeTab === 'calendar' && <DemandCalendar />}
        {activeTab === 'config' && <DemandConfig />}
        {activeTab === 'announcements' && <Announcements />}
        {activeTab === 'strikes' && <Strikes />}
      </main>
    </div>
  );
}
